const env = (import.meta as any).env || process.env
import { StorageIds } from '../constants/storage'

export enum RootDomains {
  dev = 'dev.b1smarttv.com',
  test = 'test.b1smarttv.com',
  prod = 'b1smarttv.com',
}

export type Envs = keyof typeof RootDomains // dev | test | prod

export const setRootDomainEnv = (rootDomain: string) => {
  localStorage.setItem(StorageIds.rootDomainEnv, rootDomain)
}

export const getRootDomainEnv = (): Envs => {
  return ((isDevMode && localStorage.getItem(StorageIds.rootDomainEnv)) || 'auto') as Envs
}

export const clearRootDomainEnv = () => {
  localStorage.removeItem(StorageIds.rootDomainEnv)
}

export const isEnv = (env: Envs) => {
  return getRootDomainEnv() === env
}

export const isDevMode = env.REACT_APP_IS_DEV_MODE === 'true'
export const b1RootDomain = RootDomains[getRootDomainEnv()] || env.REACT_APP_B1_ROOT_DOMAIN
export const SW_API_URL = `https://sportworld.api.${b1RootDomain}`
export const ID_API_URL = `https://identity.api.${b1RootDomain}`
export const PREVIEW_URL = `https://sportworld.api.${b1RootDomain}/v3/preview`

export const SW_URL = `https://account.${env.REACT_APP_SW_ROOT_DOMAIN}`
export const SW_ROOT_DOMAIN = `${env.REACT_APP_SW_ROOT_DOMAIN}`

export const SOCCER_DATA_API_URL = env.REACT_APP_B1_AMAGI_ROOT_DOMAIN || ''
export const cdn = `https://sportworld-public-assets.cdn.${b1RootDomain}`

export const environment = (['dev', 'test'].find((el) => b1RootDomain.startsWith(el)) || 'prod') as Envs
